import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RequestorTabState {
  activeTab: number;
}

const initialState: RequestorTabState = {
  activeTab: 1,
};

const requestorTabSlice = createSlice({
  name: 'requestorTab',
  initialState,
  reducers: {
    setRequestorActiveTab: (state, action: PayloadAction<number>) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setRequestorActiveTab } = requestorTabSlice.actions;
export default requestorTabSlice.reducer;
